/* eslint-disable camelcase */
import { UserStatistics } from './UserStatistics'

export class User {
  constructor ({ user_id = 0, username = '', email = '', profile_picture = '', user_statistics = {} } = {}) {
    this.userId = user_id
    this.username = username
    this.email = email
    this.profilePicture = profile_picture
    this.userStatistics = new UserStatistics(user_statistics)
  }

  isProfilePicture () {
    return this.profilePicture !== null && this.profilePicture !== ''
  }

  isUsername () {
    return this.username !== ''
  }

  isEmpty () {
    return this.userId === 0
  }
}
